import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { Component, OnInit } from '@angular/core';
import { SceneMode, ViewerConfiguration } from 'angular-cesium';

@Component({
    selector: 'app-globe',
    templateUrl: './globe.component.html',
    providers: [ViewerConfiguration],
    styleUrls: ['./globe.component.scss'],
})
export class GlobeComponent implements OnInit {
    sceneMode = SceneMode.SCENE3D;
    Cesium = Cesium;
    viewer = Cesium.Viewer;

    refObj: any;
    message: any;
    subscription: Subscription;
    sampleTypeId = 0;
    refData = null;

    constructor(
        private route: ActivatedRoute,
        private viewerConf: ViewerConfiguration
    ) {
        this.viewerConf.viewerOptions = {
            selectionIndicator: false,
            timeline: false,
            infoBox: false,
            fullscreenButton: false,
            baseLayerPicker: false,
            animation: false,
            shouldAnimate: false,
            homeButton: false,
            geocoder: false,
            navigationHelpButton: false,
            navigationInstructionsInitiallyVisible: false,
            mapMode2D: Cesium.MapMode2D.ROTATE,
            scene3DOnly: false,
            mapProjection: new Cesium.WebMercatorProjection(),
            dataSources: new Cesium.DataSourceCollection(),
            skyBox: false,
        };

        // Will be called on viewer initialistion
        this.viewerConf.viewerModifier = (viewer: any) => {
            // Remove default double click zoom behaviour
            viewer.screenSpaceEventHandler.removeInputAction(
                Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
            );
            viewer.scene.imageryLayers.removeAll();

            //viewer.scene.camera.lookLeft(Cesium.Math.toRadians(10));
            viewer.scene.camera.moveBackward(30000000);
            viewer.scene.backgroundColor = Cesium.Color.BLACK;

            viewer.scene.screenSpaceCameraController.minimumZoomDistance = 50000;
            viewer.scene.screenSpaceCameraController.maximumZoomDistance = 20000000;
        };
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            if (params.get('tid')) {
                this.sampleTypeId = parseInt(params.get('tid'), 0);
                this.refData = { sampleTypeId: this.sampleTypeId };
            }
            if (params.get('rid')) {
                this.refData = {
                    refId: parseInt(params.get('rid'), 0),
                    sampleTypeId: this.sampleTypeId,
                };
            }
        });
    }
}
